import axios from 'axios';
import { Component } from 'san';
import { IDashboardItem } from 'src/models/dashboard';
import DashboardBar from '../DashboardBar/DashboardBar';
import DashboardDoughnut from '../DashboardDoughnut/DashboardDoughnut';
import DashboardLine from '../DashboardLine/DashboardLine';
import DashboardPie from '../DashboardPie/DashboardPie';
import * as moment from 'moment';

export default class Dashboard extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
        'ui-dashboard-doughnut': DashboardDoughnut,
        'ui-dashboard-bar': DashboardBar,
        'ui-dashboard-line': DashboardLine,
        'ui-dashboard-pie': DashboardPie,
    };

    initData(): {
        assignedItems: IDashboardItem;
        managedItems: IDashboardItem;
        personLiableItems: IDashboardItem;
        projectLevels: IDashboardItem;
        projectTypes: IDashboardItem;
        projectTypesWithStatus: IDashboardItem[];
        projectStatus: IDashboardItem[];
        showLine: boolean;
    } {
        return {
            assignedItems: { type: '', items: [] },
            managedItems: { type: '', items: [] },
            personLiableItems: { type: '', items: [] },
            projectLevels: { type: '', items: [] },
            projectTypes: { type: '', items: [] },
            projectTypesWithStatus: [],
            projectStatus: [],
            showLine: false,
        };
    }

    inited() {
        this.getData();
        this.getRangeData();
    }

    getData() {
        return axios.get(`/api/dashboard/data`).then((result) => {
            this.data.set('assignedItems', result.data.assigned_items);
            this.data.set('managedItems', result.data.managed_items);
            this.data.set('personLiableItems', result.data.person_liable_items);
            this.data.set('projectLevels', result.data.project_levels);
            this.data.set('projectTypes', result.data.project_types);
            this.data.set('projectTypesWithStatus', result.data.project_types_with_status);
        });
    }

    getRangeData() {
        // 默认展示今天前30天
        const end = moment(new Date()).format('YYYY-MM-DD');
        const begin = moment().subtract(29, 'days').format('YYYY-MM-DD');
        const params = {
            begin,
            end,
        }
        return axios.get(`/api/dashboard/range-data`, {params}).then((result) => {
            this.data.set('projectStatus', result.data);
            this.data.set('showLine', true);
        });
    }
}